import { faEdit, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ColumnDescription } from "react-bootstrap-table-next";
import {
    AtualizarPerfilTipoContaController,
    DeletarPerfilTipoContaController,
} from "../../../../../../../Controllers/Geral/CadastroEEditaTipoConta/CadastroEEditaTipoContaController";
import { IPerfilTipoCliente } from "../../../../../../../Interfaces/Geral/CadastroEEditaTipoCliente/CadastroEEditaTipoClienteInterface";
import { Switch } from "../../../../../../CardsPages/Forms/Switch";
import Table from "../../../../../../Table";

interface IListagemTipoClienteProps {
    lstTipoCliente: Array<IPerfilTipoCliente>;
    setEdit: (tpa: IPerfilTipoCliente) => void;
    updateList: () => void;
}

export default function ListagemTipoCliente(props: IListagemTipoClienteProps) {
    const columns: Array<ColumnDescription<IPerfilTipoCliente>> = [
        {
            dataField: "ID_PERFIL_TIPO_CONTA",
            text: "Tipos",
            formatExtraData: props.setEdit,
            formatter: (c, row, _, setEdit) => (
                <div className="d-flex justify-content-between align-items-center p-3 g-2">
                    <div className="d-flex align-items-center g-3">
                        <i
                            className={`${row.DS_ICON_PERFIL_TIPO_CONTA}`}
                            style={{ color: row.HX_COR_PERFIL_TIPO_CONTA }}
                        />
                        <div>
                            <h6>{row.DS_PERFIL_TIPO_CONTA}</h6>
                            <div className="d-flex flex-wrap g-1">
                                <span
                                    className={`label label-${
                                        row.FL_ATIVO ? "success" : "danger"
                                    } abel-pill label-inline mr-2`}
                                >
                                    {row.FL_ATIVO ? "Ativo" : "Desativado"}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex flex-wrap g-2">
                        <button
                            className="btn btn-icon btn-outline-danger"
                            onClick={() => {
                                DeletarPerfilTipoContaController(
                                    row.ID_PERFIL_TIPO_CONTA
                                ).then(() => props.updateList());
                            }}
                        >
                            <FontAwesomeIcon icon={faTrash} />
                        </button>
                        <button
                            className="btn btn-icon btn-outline-primary"
                            onClick={() => {
                                setEdit(row);
                            }}
                        >
                            <FontAwesomeIcon icon={faEdit} />
                        </button>
                        <Switch
                            color="success"
                            type="checkbox"
                            title={row.FL_ATIVO ? "Desativar" : "Ativar"}
                            checked={row.FL_ATIVO}
                            onChange={() => {
                                AtualizarPerfilTipoContaController({
                                    ...row,
                                    FL_ATIVO: !row.FL_ATIVO,
                                }).then(props.updateList);
                            }}
                        />
                    </div>
                </div>
            ),
        },
    ];

    return (
        <Table
            keyField="ID_TIPO_CLIENTE"
            data={props.lstTipoCliente}
            columns={columns}
            noDataIndication={"Não existe Tipo Agendamento"}
        />
    );
}
